import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["portrait", "buttonStyle", "linesStyle", "style"],
    _excluded2 = ["boxSizing", "objectFit", "objectPosition"],
    _excluded3 = ["handle", "itemOne", "itemTwo", "onlyHandleDraggable", "onPositionChange", "portrait", "position", "boundsPadding", "changePositionOnHover", "style"],
    _excluded4 = ["style"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { forwardRef, useRef, useEffect, useCallback, useLayoutEffect, useState } from 'react';
/** Container for clipped item. */

var ContainerClip = /*#__PURE__*/forwardRef(function (props, ref) {
  var style = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    willChange: 'clip',
    userSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none'
  };
  return React.createElement("div", Object.assign({}, props, {
    style: style,
    "data-rcs": "clip-item",
    ref: ref
  }));
});
ContainerClip.displayName = 'ContainerClip';
/** Container to control the handle's position. */

var ContainerHandle = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      portrait = _ref.portrait;
  var style = {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none'
  };
  var innerStyle = {
    position: 'absolute',
    width: portrait ? '100%' : undefined,
    height: portrait ? undefined : '100%',
    transform: portrait ? 'translateY(-50%)' : 'translateX(-50%)',
    pointerEvents: 'all'
  };
  return React.createElement("div", {
    style: style,
    "data-rcs": "handle-container",
    ref: ref
  }, React.createElement("div", {
    style: innerStyle
  }, children));
});
ContainerHandle.displayName = 'ThisHandleContainer';

var ThisArrow = function ThisArrow(_ref2) {
  var flip = _ref2.flip;
  var style = {
    width: 0,
    height: 0,
    borderTop: '8px solid transparent',
    borderRight: '10px solid',
    borderBottom: '8px solid transparent',
    transform: flip ? 'rotate(180deg)' : undefined
  };
  return React.createElement("div", {
    style: style
  });
};
/** Default `handle`. */


var ReactCompareSliderHandle = function ReactCompareSliderHandle(_ref3) {
  var portrait = _ref3.portrait,
      buttonStyle = _ref3.buttonStyle,
      linesStyle = _ref3.linesStyle,
      style = _ref3.style,
      props = _objectWithoutProperties(_ref3, _excluded);

  var _style = _objectSpread({
    display: 'flex',
    flexDirection: portrait ? 'row' : 'column',
    placeItems: 'center',
    height: '100%',
    cursor: portrait ? 'ns-resize' : 'ew-resize',
    pointerEvents: 'none',
    color: '#fff'
  }, style);

  var _linesStyle = _objectSpread({
    flexGrow: 1,
    height: portrait ? 2 : '100%',
    width: portrait ? '100%' : 2,
    backgroundColor: 'currentColor',
    pointerEvents: 'auto',
    boxShadow: '0 0 7px rgba(0,0,0,.35)'
  }, linesStyle);

  var _buttonStyle = _objectSpread({
    display: 'grid',
    gridAutoFlow: 'column',
    gap: 8,
    placeContent: 'center',
    flexShrink: 0,
    width: 56,
    height: 56,
    borderRadius: '50%',
    borderStyle: 'solid',
    borderWidth: 2,
    pointerEvents: 'auto',
    backdropFilter: 'blur(7px)',
    WebkitBackdropFilter: 'blur(7px)',
    boxShadow: '0 0 7px rgba(0,0,0,.35)',
    transform: portrait ? 'rotate(90deg)' : undefined
  }, buttonStyle);

  return React.createElement("div", Object.assign({
    className: "__rcs-handle-root"
  }, props, {
    style: _style
  }), React.createElement("div", {
    className: "__rcs-handle-line",
    style: _linesStyle
  }), React.createElement("div", {
    className: "__rcs-handle-button",
    style: _buttonStyle
  }, React.createElement(ThisArrow, null), React.createElement(ThisArrow, {
    flip: true
  })), React.createElement("div", {
    className: "__rcs-handle-line",
    style: _linesStyle
  }));
};
/**
 * Stand-alone CSS utility to make replaced elements (`img`, `video`, etc.) fit their
 * container.
 */


var styleFitContainer = function styleFitContainer() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$boxSizing = _ref4.boxSizing,
      boxSizing = _ref4$boxSizing === void 0 ? 'border-box' : _ref4$boxSizing,
      _ref4$objectFit = _ref4.objectFit,
      objectFit = _ref4$objectFit === void 0 ? 'cover' : _ref4$objectFit,
      _ref4$objectPosition = _ref4.objectPosition,
      objectPosition = _ref4$objectPosition === void 0 ? 'center' : _ref4$objectPosition,
      props = _objectWithoutProperties(_ref4, _excluded2);

  return _objectSpread({
    display: 'block',
    width: '100%',
    height: '100%',
    maxWidth: '100%',
    boxSizing: boxSizing,
    objectFit: objectFit,
    objectPosition: objectPosition
  }, props);
};
/** Store the previous supplied value. */


var usePrevious = function usePrevious(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};
/**
 * Event listener binding hook.
 * @param eventName      - Event to bind to.
 * @param handler        - Callback handler.
 * @param element        - Element to bind to.
 * @param handlerOptions - Event handler options.
 */


var useEventListener = function useEventListener(eventName, handler, element, handlerOptions) {
  var savedHandler = useRef();
  useEffect(function () {
    savedHandler.current = handler;
  }, [handler]);
  useEffect(function () {
    // Make sure element supports addEventListener.
    if (!(element && element.addEventListener)) return; // Create event listener that calls handler function stored in ref.

    var eventListener = function eventListener(event) {
      return savedHandler.current && savedHandler.current(event);
    };

    element.addEventListener(eventName, eventListener, handlerOptions);
    return function () {
      element.removeEventListener(eventName, eventListener, handlerOptions);
    };
  }, [eventName, element, handlerOptions]);
};
/**
 * Conditionally use `useLayoutEffect` for client *or* `useEffect` for SSR.
 * @see <https://github.com/reduxjs/react-redux/blob/c581d480dd675f2645851fb006bef91aeb6ac24d/src/utils/useIsomorphicLayoutEffect.js>
 */


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? useLayoutEffect : useEffect;
/**
 * Bind resize observer callback to element.
 * @param ref       - Element to bind to.
 * @param handler   - Callback for handling entry's bounding rect.
 */

var useResizeObserver = function useResizeObserver(ref, handler) {
  var observer = useRef();
  var observe = useCallback(function () {
    if (ref.current && observer.current) observer.current.observe(ref.current);
  }, [ref]); // Bind/rebind observer when `handler` changes.

  useIsomorphicLayoutEffect(function () {
    observer.current = new ResizeObserver(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 1),
          entry = _ref6[0];

      return handler(entry.contentRect);
    });
    observe();
    return function () {
      if (observer.current) observer.current.disconnect();
    };
  }, [handler, observe]);
};

var EVENT_PASSIVE_PARAMS = {
  passive: true
};
var EVENT_CAPTURE_PARAMS = {
  capture: true,
  passive: false
};
/** Root Comparison slider. */

var ReactCompareSlider = function ReactCompareSlider(_ref7) {
  var handle = _ref7.handle,
      itemOne = _ref7.itemOne,
      itemTwo = _ref7.itemTwo,
      _ref7$onlyHandleDragg = _ref7.onlyHandleDraggable,
      onlyHandleDraggable = _ref7$onlyHandleDragg === void 0 ? false : _ref7$onlyHandleDragg,
      onPositionChange = _ref7.onPositionChange,
      _ref7$portrait = _ref7.portrait,
      portrait = _ref7$portrait === void 0 ? false : _ref7$portrait,
      _ref7$position = _ref7.position,
      position = _ref7$position === void 0 ? 50 : _ref7$position,
      _ref7$boundsPadding = _ref7.boundsPadding,
      boundsPadding = _ref7$boundsPadding === void 0 ? 0 : _ref7$boundsPadding,
      _ref7$changePositionO = _ref7.changePositionOnHover,
      changePositionOnHover = _ref7$changePositionO === void 0 ? false : _ref7$changePositionO,
      style = _ref7.style,
      props = _objectWithoutProperties(_ref7, _excluded3);

  /** DOM node of the root element. */
  var rootContainerRef = useRef(null);
  /** DOM node of the item that is clipped. */

  var clipContainerRef = useRef(null);
  /** DOM node of the handle container. */

  var handleContainerRef = useRef(null);
  /** Current position as a percentage value (initially negative to sync bounds on mount). */

  var internalPositionPc = useRef(position);
  /** Previous `position` prop value. */

  var prevPropPosition = usePrevious(position);
  /** Whether user is currently dragging. */

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDragging = _useState2[0],
      setIsDragging = _useState2[1];
  /** Whether component has a `window` event binding. */


  var hasWindowBinding = useRef(false);
  /** Target container for pointer events. */

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      interactiveTarget = _useState4[0],
      setInteractiveTarget = _useState4[1];
  /** Whether the bounds of the container element have been synchronised. */


  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      didSyncBounds = _useState6[0],
      setDidSyncBounds = _useState6[1]; // Set target container for pointer events.


  useEffect(function () {
    setInteractiveTarget(onlyHandleDraggable ? handleContainerRef.current : rootContainerRef.current);
  }, [onlyHandleDraggable]);
  /** Update internal position value. */

  var updateInternalPosition = useCallback(function updateInternalCall(_ref8) {
    var x = _ref8.x,
        y = _ref8.y,
        isOffset = _ref8.isOffset,
        _portrait = _ref8.portrait,
        _boundsPadding = _ref8.boundsPadding;

    var _rootContainerRef$cur = rootContainerRef.current.getBoundingClientRect(),
        top = _rootContainerRef$cur.top,
        left = _rootContainerRef$cur.left,
        width = _rootContainerRef$cur.width,
        height = _rootContainerRef$cur.height; // Early out if width or height are zero, can't calculate values
    // from zeros.


    if (width === 0 || height === 0) return;
    /**
     * Pixel position clamped within the container's bounds.
     * @NOTE This does *not* take `boundsPadding` into account because we need
     *       the full coords to correctly position the handle.
     */

    var positionPx = Math.min(Math.max( // Determine bounds based on orientation
    _portrait ? isOffset ? y - top - window.pageYOffset : y : isOffset ? x - left - window.pageXOffset : x, // Min value
    0), // Max value
    _portrait ? height : width);
    /** Width or height with CSS scaling accounted for. */

    var zoomScale = _portrait ? height / (rootContainerRef.current.offsetHeight || 1) : width / (rootContainerRef.current.offsetWidth || 1);
    var adjustedPosition = positionPx / zoomScale;
    var adjustedWidth = width / zoomScale;
    var adjustedHeight = height / zoomScale;
    /**
     * Internal position percentage *without* bounds.
     * @NOTE This uses the entire container bounds **without** `boundsPadding`
     *       to get the *real* bounds.
     */

    var nextInternalPositionPc = adjustedPosition / (_portrait ? adjustedHeight : adjustedWidth) * 100;
    /** Whether the current pixel position meets the min/max bounds. */

    var positionMeetsBounds = _portrait ? adjustedPosition === 0 || adjustedPosition === adjustedHeight : adjustedPosition === 0 || adjustedPosition === adjustedWidth;
    var canSkipPositionPc = nextInternalPositionPc === internalPositionPc.current && (internalPositionPc.current === 0 || internalPositionPc.current === 100); // Early out if pixel and percentage positions are already at the min/max
    // to prevent update spamming when the user is sliding outside of the
    // container.

    if (didSyncBounds && canSkipPositionPc && positionMeetsBounds) {
      return;
    } else {
      setDidSyncBounds(true);
    } // Set new internal position.


    internalPositionPc.current = nextInternalPositionPc;
    /** Pixel position clamped to extremities *with* bounds padding. */

    var clampedPx = Math.min( // Get largest from pixel position *or* bounds padding.
    Math.max(adjustedPosition, 0 + _boundsPadding), // Use height *or* width based on orientation.
    (_portrait ? adjustedHeight : adjustedWidth) - _boundsPadding);
    clipContainerRef.current.style.clip = _portrait ? "rect(auto,auto,".concat(clampedPx, "px,auto)") : "rect(auto,".concat(clampedPx, "px,auto,auto)");
    handleContainerRef.current.style.transform = _portrait ? "translate3d(0,".concat(clampedPx, "px,0)") : "translate3d(".concat(clampedPx, "px,0,0)");
    if (onPositionChange) onPositionChange(internalPositionPc.current);
  }, [didSyncBounds, onPositionChange]); // Update internal position when other user controllable props change.

  useEffect(function () {
    var _rootContainerRef$cur2 = rootContainerRef.current.getBoundingClientRect(),
        width = _rootContainerRef$cur2.width,
        height = _rootContainerRef$cur2.height; // Use current internal position if `position` hasn't changed.


    var nextPosition = position === prevPropPosition ? internalPositionPc.current : position;
    updateInternalPosition({
      portrait: portrait,
      boundsPadding: boundsPadding,
      x: width / 100 * nextPosition,
      y: height / 100 * nextPosition
    });
  }, [portrait, position, prevPropPosition, boundsPadding, updateInternalPosition]);
  /** Handle mouse/touch down. */

  var handlePointerDown = useCallback(function (ev) {
    ev.preventDefault();
    updateInternalPosition({
      portrait: portrait,
      boundsPadding: boundsPadding,
      isOffset: true,
      x: ev instanceof MouseEvent ? ev.pageX : ev.touches[0].pageX,
      y: ev instanceof MouseEvent ? ev.pageY : ev.touches[0].pageY
    });
    setIsDragging(true);
  }, [portrait, boundsPadding, updateInternalPosition]);
  /** Handle mouse/touch move. */

  var handlePointerMove = useCallback(function moveCall(ev) {
    updateInternalPosition({
      portrait: portrait,
      boundsPadding: boundsPadding,
      isOffset: true,
      x: ev instanceof MouseEvent ? ev.pageX : ev.touches[0].pageX,
      y: ev instanceof MouseEvent ? ev.pageY : ev.touches[0].pageY
    });
  }, [portrait, boundsPadding, updateInternalPosition]);
  /** Handle mouse/touch up. */

  var handlePointerUp = useCallback(function () {
    setIsDragging(false);
  }, []);
  /** Resync internal position on resize. */

  var handleResize = useCallback(function (_ref9) {
    var width = _ref9.width,
        height = _ref9.height;

    var _rootContainerRef$cur3 = rootContainerRef.current.getBoundingClientRect(),
        scaledWidth = _rootContainerRef$cur3.width,
        scaledHeight = _rootContainerRef$cur3.height;

    updateInternalPosition({
      portrait: portrait,
      boundsPadding: boundsPadding,
      x: width / 100 * internalPositionPc.current * scaledWidth / width,
      y: height / 100 * internalPositionPc.current * scaledHeight / height
    });
  }, [portrait, boundsPadding, updateInternalPosition]); // Allow drag outside of container while pointer is still down.

  useEffect(function () {
    if (isDragging && !hasWindowBinding.current) {
      window.addEventListener('mousemove', handlePointerMove, EVENT_PASSIVE_PARAMS);
      window.addEventListener('mouseup', handlePointerUp, EVENT_PASSIVE_PARAMS);
      window.addEventListener('touchmove', handlePointerMove, EVENT_PASSIVE_PARAMS);
      window.addEventListener('touchend', handlePointerUp, EVENT_PASSIVE_PARAMS);
      hasWindowBinding.current = true;
    }

    return function () {
      if (hasWindowBinding.current) {
        window.removeEventListener('mousemove', handlePointerMove);
        window.removeEventListener('mouseup', handlePointerUp);
        window.removeEventListener('touchmove', handlePointerMove);
        window.removeEventListener('touchend', handlePointerUp);
        hasWindowBinding.current = false;
      }
    };
  }, [handlePointerMove, handlePointerUp, isDragging]); // Bind resize observer to container.

  useResizeObserver(rootContainerRef, handleResize); // Handle hover events on the container.

  useEffect(function () {
    var containerRef = rootContainerRef.current;

    var handleMouseLeave = function handleMouseLeave() {
      if (isDragging) return;
      handlePointerUp();
    };

    if (changePositionOnHover) {
      containerRef.addEventListener('mousemove', handlePointerMove, EVENT_PASSIVE_PARAMS);
      containerRef.addEventListener('mouseleave', handleMouseLeave, EVENT_PASSIVE_PARAMS);
    }

    return function () {
      containerRef.removeEventListener('mousemove', handlePointerMove);
      containerRef.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [changePositionOnHover, handlePointerMove, handlePointerUp, isDragging]);
  useEventListener('mousedown', handlePointerDown, interactiveTarget, EVENT_CAPTURE_PARAMS);
  useEventListener('touchstart', handlePointerDown, interactiveTarget, EVENT_CAPTURE_PARAMS); // Use custom handle if requested.

  var Handle = handle || React.createElement(ReactCompareSliderHandle, {
    portrait: portrait
  });

  var rootStyle = _objectSpread({
    position: 'relative',
    overflow: 'hidden',
    cursor: isDragging ? portrait ? 'ns-resize' : 'ew-resize' : undefined,
    userSelect: 'none',
    KhtmlUserSelect: 'none',
    msUserSelect: 'none',
    MozUserSelect: 'none',
    WebkitUserSelect: 'none'
  }, style);

  return React.createElement("div", Object.assign({}, props, {
    ref: rootContainerRef,
    style: rootStyle,
    "data-rcs": "root"
  }), itemTwo, React.createElement(ContainerClip, {
    ref: clipContainerRef
  }, itemOne), React.createElement(ContainerHandle, {
    portrait: portrait,
    ref: handleContainerRef
  }, Handle));
};
/** Image with defaults from `styleFitContainer` applied. */


var ReactCompareSliderImage = function ReactCompareSliderImage(_ref10) {
  var style = _ref10.style,
      props = _objectWithoutProperties(_ref10, _excluded4);

  var rootStyle = styleFitContainer(style);
  return React.createElement("img", Object.assign({}, props, {
    style: rootStyle,
    "data-rcs": "image"
  }));
};

export { ReactCompareSlider, ReactCompareSliderHandle, ReactCompareSliderImage, styleFitContainer };